export const EMAIL_TEMPLATE_LIST_ACTION = "EMAIL_TEMPLATE_LIST_ACTION";
export const EMAIL_TEMPLATE_LIST_SUCCESS = "EMAIL_TEMPLATE_LIST_SUCCESS";

export const EMAIL_TEMPLATE_ALL_ACTION = "EMAIL_TEMPLATE_ALL_ACTION";
export const EMAIL_TEMPLATE_ALL_SUCCESS = "EMAIL_TEMPLATE_ALL_SUCCESS";

export const EMAIL_TEMPLATE_DETAIL_ACTION = "EMAIL_TEMPLATE_DETAIL_ACTION";
export const EMAIL_TEMPLATE_DETAIL_SUCCESS = "EMAIL_TEMPLATE_DETAIL_SUCCESS";

export const EMAIL_TEMPLATE_DETAIL_UPDATE_ACTION = "EMAIL_TEMPLATE_DETAIL_UPDATE_ACTION";
export const EMAIL_TEMPLATE_DETAIL_CREATE_ACTION = "EMAIL_TEMPLATE_DETAIL_CREATE_ACTION";
export const EMAIL_TEMPLATE_DETAIL_DELETE_ACTION = "EMAIL_TEMPLATE_DETAIL_DELETE_ACTION";

export const EMAIL_TEMPLATE_CREATE_TRANSLATE_ACTION = "EMAIL_TEMPLATE_CREATE_TRANSLATE_ACTION";
export const EMAIL_TEMPLATE_CREATE_TRANSLATE_SUCCESS = "EMAIL_TEMPLATE_CREATE_TRANSLATE_SUCCESS";

export const EMAIL_TEMPLATE_UPDATE_TRANSLATE_ACTION = "EMAIL_TEMPLATE_UPDATE_TRANSLATE_ACTION";
export const EMAIL_TEMPLATE_UPDATE_TRANSLATE_SUCCESS = "EMAIL_TEMPLATE_UPDATE_TRANSLATE_SUCCESS";

export const EMAIL_TEMPLATE_DELETE_TRANSLATE_ACTION = "EMAIL_TEMPLATE_DELETE_TRANSLATE_ACTION";
export const EMAIL_TEMPLATE_DELETE_TRANSLATE_SUCCESS = "EMAIL_TEMPLATE_DELETE_TRANSLATE_SUCCESS";

export const EMAIL_TEMPLATE_FAIL = "EMAIL_TEMPLATE_FAIL";
